import React from "react";
import { NavLink } from "react-router-dom";

export const NavLinkR = ({ title, link }) => {
  return (
    <li
      className="text-[16px] cursor-pointer font-Play
      "
    >
      <NavLink to={link}>{title}</NavLink>
    </li>
  );
};

export const NavLinkActive = ({ title, link, mobile }) => {
  return (
    <>
      {mobile ? (
        <li
          className="cursor-pointer text-[16px] text-center
       relative text-[#6768F6]
       
       "
        >
          {title}
        </li>
      ) : (
        <li
          className="text-[16px] cursor-pointer font-Play text-center
      relative  before:absolute before:w-[5px] before:h-[5px] before:bg-[#FBDA79] before:-top-1 before:left-1/2 before:rounded-full ml-3 
      
      "
        >
          <NavLink to={link}>{title}</NavLink>
        </li>
      )}
    </>
  );
};
